import * as React from "react";
import { cva, type VariantProps } from "class-variance-authority";

import { cn } from "@/lib/utils";

const badgeVariants = cva(
  "inline-flex items-center rounded-lg border px-2.5 py-0.5 text-xs font-semibold transition-colors duration-150 focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2",
  {
    variants: {
      variant: {
        default: "border-transparent bg-primary text-primary-foreground hover:bg-primary/80",
        secondary: "border-transparent bg-secondary text-secondary-foreground hover:bg-secondary/80",
        destructive: "border-transparent bg-destructive text-destructive-foreground hover:bg-destructive/80",
        outline: "text-foreground",
        success: "border-transparent bg-success/10 text-success",
        warning: "border-transparent bg-warning/10 text-warning",
        info: "border-transparent bg-info/10 text-info",
        progress: "border-transparent bg-progress/10 text-progress",
        paused: "border-transparent bg-paused/10 text-paused",
        expired: "border-transparent bg-expired/10 text-expired",
        muted: "border-transparent bg-muted text-muted-foreground",
        cluster1: "border-transparent bg-cluster-1 text-white",
        cluster2: "border-transparent bg-cluster-2 text-white",
        cluster3: "border-transparent bg-cluster-3 text-white",
        cluster4: "border-transparent bg-cluster-4 text-white",
        cluster5: "border-transparent bg-cluster-5 text-white",
        cluster6: "border-transparent bg-cluster-6 text-white",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  },
);

export interface BadgeProps extends React.HTMLAttributes<HTMLDivElement>, VariantProps<typeof badgeVariants> {}

function Badge({ className, variant, ...props }: BadgeProps) {
  return <div className={cn(badgeVariants({ variant }), className)} {...props} />;
}

export { Badge, badgeVariants };
